/* The Aesthetic Cove — Santa's Nice List.
   Type a first name and press the button: the list scrolls down to the next
   empty line, the name is written in with a red tick, a NICE stamp lands on
   the paper, and the name appears on a bauble beside a button that opens the
   one-name bauble ("Put Olivia's name on a bauble").

   The name stays in the page; nothing is sent anywhere or saved. Visitors
   who prefer reduced motion get the finished list straight away. */
(() => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  document.querySelectorAll('[data-nice-list]').forEach((section) => {
    if (section.dataset.ready) return;
    section.dataset.ready = '1';

    const $ = (sel) => section.querySelector(sel);
    const form = $('[data-nice-form]');
    const input = form && form.querySelector('input');
    const submit = $('[data-nice-submit]');
    const error = $('[data-nice-error]');
    const list = $('[data-nice-names]');
    const line = $('[data-nice-line]');
    const written = $('[data-nice-written]');
    const verdict = $('[data-nice-verdict]');
    const offer = $('[data-nice-offer]');
    const bauble = $('[data-nice-bauble]');
    const cta = $('[data-nice-cta]');
    if (!form || !input || !list || !line) return;

    const ctaTemplate = cta ? cta.textContent.trim() : '';
    const buttonText = submit ? submit.textContent : '';
    let timers = [];
    const later = (ms, fn) => timers.push(setTimeout(fn, reduce ? 0 : ms));
    const clear = () => {
      timers.forEach(clearTimeout);
      timers = [];
    };

    // "olivia rose" -> "Olivia Rose"; letters, spaces, hyphens and apostrophes only.
    const tidy = (raw) =>
      raw
        .replace(/[^\p{L}\p{M}' ’.-]/gu, '')
        .replace(/\s+/g, ' ')
        .trim()
        .slice(0, 18)
        .split(' ')
        .map((w) => w.charAt(0).toLocaleUpperCase() + w.slice(1))
        .join(' ');
    const possessive = (name) => (/s$/i.test(name) ? `${name}’` : `${name}’s`);

    // Bring the empty line into the middle of the window.
    const scrollTo = (el, animate) => {
      const win = list.parentElement;
      const offset = Math.max(0, el.offsetTop - (win.clientHeight - el.offsetHeight) / 2);
      list.style.transition = animate && !reduce ? '' : 'none';
      list.style.transform = `translateY(${-offset}px)`;
    };

    form.addEventListener('submit', (e) => {
      e.preventDefault();
      const name = tidy(input.value);
      if (!name) {
        if (error) error.hidden = false;
        input.focus();
        return;
      }
      if (error) error.hidden = true;
      clear();

      // Reset to the top of the list without animating, then run.
      section.classList.remove('is-written', 'is-stamped', 'is-done');
      if (offer) offer.hidden = true;
      if (verdict) verdict.textContent = '';
      written.textContent = name;
      list.style.transition = 'none';
      list.style.transform = 'translateY(0)';
      void list.offsetHeight;

      section.classList.add('is-checking');
      if (submit) {
        submit.disabled = true;
        submit.textContent = 'Checking…';
      }
      later(60, () => scrollTo(line, true));
      later(1500, () => submit && (submit.textContent = 'Checking twice…'));
      later(1900, () => section.classList.add('is-written'));
      later(2700, () => section.classList.add('is-stamped'));
      later(3100, () => {
        section.classList.remove('is-checking');
        section.classList.add('is-done');
        if (verdict) verdict.textContent = `Good news. ${name} is on the Nice List.`;
        if (bauble) bauble.textContent = name;
        if (cta) cta.textContent = ctaTemplate.includes('their') ? ctaTemplate.replace('their', possessive(name)) : ctaTemplate;
        if (offer) offer.hidden = false;
        if (submit) {
          submit.disabled = false;
          submit.textContent = buttonText;
        }
      });
    });

    input.addEventListener('input', () => {
      if (error && !error.hidden && input.value.trim()) error.hidden = true;
    });
  });
})();
